import React from "react";

export default function stepTwo(props) {
  const { nextStep, befStep } = props;
  let next = (e) => {
    e.preventDefault();
    nextStep();
  };
  let before = (e) => {
    e.preventDefault();
    befStep();
  };
  return (
    <div>
      Step two
      <button
        onClick={(e) => {
          before(e);
        }}
      >
        before
      </button>
      <button
        onClick={(e) => {
          next(e);
        }}
      >
        next
      </button>
    </div>
  );
}
